import { VStack } from '@chakra-ui/react';
import { DRAFT_STATUTES_MENTIONS } from '@shinetools/capital-deposits-library';

import asBentoPage from 'common/bento/hoc/asBentoPage';
import useCopyTextToClipboard from 'common/hooks/useCopyTextToClipboard';
import Button from 'components/_core/Button';
import Callout from 'components/_core/Callout';
import Text from 'components/_core/Text';
import Header from 'features/Onboarding/components/Header';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';
import Checklist from 'features/Onboarding/components/OBUpload/components/Checklist/Checklist';

import locales from './locales';

interface PrepareDraftStatutesProps {
  onNext: () => void;
  isMandatee: boolean;
}

const PrepareDraftStatutes = asBentoPage<PrepareDraftStatutesProps>(
  ({ isMandatee, Layout, onNext, onPrev }) => {
    const onCopyMentionApports = useCopyTextToClipboard({
      copySuccessMessage: locales.textCopied,
      textToCopy: DRAFT_STATUTES_MENTIONS.APPORTS,
    });
    const onCopyMentionAppendix = useCopyTextToClipboard({
      copySuccessMessage: locales.textCopied,
      textToCopy: DRAFT_STATUTES_MENTIONS.APPENDIX,
    });

    return (
      <Layout nav={<OBNavigation onPrev={onPrev} />}>
        <Header
          description={
            <Checklist
              checks={locales.elementsList.map((element) => element)}
              description={locales.description}
            />
          }
          title={
            isMandatee ? locales.title.mandatee : locales.title.nonMandatee
          }
        />
        <VStack paddingBottom="space-48" spacing="space-32">
          <VStack alignItems="left" spacing="space-16">
            <Text size="lg" variant="primary">
              {isMandatee ? locales.intro.mandatee : locales.intro.nonMandatee}
            </Text>

            <Text size="md" variant="light">
              {locales.mentionApports}
            </Text>

            <Callout hideIcon>
              <Callout.Content>
                {DRAFT_STATUTES_MENTIONS.APPORTS}
              </Callout.Content>

              <Callout.Button
                icon="copy"
                iconPosition="left"
                onClick={() => onCopyMentionApports()}
              >
                {locales.copyClipboard}
              </Callout.Button>
            </Callout>
          </VStack>

          <VStack spacing="space-16">
            <Text size="md" variant="light">
              {locales.mentionAppendix}
            </Text>

            <Callout hideIcon>
              <Callout.Content>
                {DRAFT_STATUTES_MENTIONS.APPENDIX}
              </Callout.Content>

              <Callout.Button
                icon="copy"
                iconPosition="left"
                onClick={() => onCopyMentionAppendix()}
              >
                {locales.copyClipboard}
              </Callout.Button>
            </Callout>
          </VStack>
          <Button isExpanded onClick={onNext}>
            {isMandatee
              ? locales.ctaContinue.mandatee
              : locales.ctaContinue.nonMandatee}
          </Button>
        </VStack>
      </Layout>
    );
  },
);

export default PrepareDraftStatutes;
